var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-detail"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',{staticClass:"release-time"},[_vm._v(_vm._s(_vm.parseTime(_vm.info.pushTime,'{y}-{m}-{d}')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)},on:{"click":_vm.prviewPhoto}})])
}
var staticRenderFns = []

export { render, staticRenderFns }